import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';

/** Summary + PDF of the visa retainer for an application (signed copy when signed). */
export const fetchRetainerAgreement = createAsyncThunk('retainerAgreement/fetch', (appId: string) =>
    api.signRetainer.getAgreementDocument(appId)
);
